import { Button } from "primereact/button";
import React from "react";
import { useSelector } from "react-redux";
import { handlePutRequest } from "../../../services/PutTemplate";

function EnableorDisableUser({ handleCancel, getCompanyUsersDetail }) {
    const editFlag__Store = useSelector((state) => state.companySlice?.companyUsersEditFlag);
    const userId = useSelector((state) => state.companySlice?.companyUsersFormData?.userId);
    const isDisable = useSelector((state) => state.companySlice?.companyUsersFormData?.isActive);

    const enableorDisableUser = async (e) => {
        const data = {
            userId,
            isActive: isDisable === "N" ? "Y" : "N",
        };
        try {
            await handlePutRequest(data, "zbizgateway/nonFin/enableDisableCompanyUser/");
            getCompanyUsersDetail();
            handleCancel(e);
        } catch (error) {
            console.log(error);
        }
    };

    if (!editFlag__Store) {
        return null;
    }

    if (isDisable === "N") {
        return <Button type="button" label="Enable User" className="Btn__Transparent" style={{ marginRight: "10px" }} onClick={enableorDisableUser} />;
    }

    return <Button type="button" label="Disable User" className="Btn__Transparent" style={{ marginRight: "10px" }} onClick={enableorDisableUser} />;
}

export default EnableorDisableUser;
